
import { useEffect, useState } from "react";
import { blogService } from "services/Services";

type BlogProps = {
  id: string;
};

const Blog = ({ id }: BlogProps) => {
  const [html, setHtml] = useState<string | null>(null);

  useEffect(() => {
    blogService.GetBlog(id).then(content => {
      if (content) {
        setHtml(content);
      } else {
        setHtml(null); 
      }
    });
  }, [id]);

  if (html === null) return null;

  return <div dangerouslySetInnerHTML={{ __html: html }} />;
};

export default Blog;
